import { render, staticRenderFns } from "./VerifyView.vue?vue&type=template&id=863f29f0"
import script from "./VerifyView.vue?vue&type=script&lang=js"
export * from "./VerifyView.vue?vue&type=script&lang=js"
import style0 from "./VerifyView.vue?vue&type=style&index=0&id=863f29f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports